import * as cnt from './actions';
import { takeLatest } from 'redux-saga/effects';
import { partner as partnerApis } from '../../../api';
import { apiSaga } from '../../../sagas';

function* doAddConnectAsPartner({ payload }) {
  yield* apiSaga(cnt.ADD_CONNECTION_AS_PARTNER, partnerApis.addConnectionAsPartner, [payload]);
}

export default [
  takeLatest(cnt.ADD_CONNECTION_AS_PARTNER, doAddConnectAsPartner),
];



// WEBPACK FOOTER //
// ./src/app/components/connections/__storeFiles__/sagas.js